// Roboto, the repo's standard font, embedded in a jsPDF document. jsPDF needs
// static TTFs (not the app's variable woff2): Roboto Regular and Bold, SIL Open
// Font License 1.1 (fonts/OFL.txt), which allows embedding. They are bundle
// assets, so the offline shell keeps them on the device; jsPDF embeds only the
// characters a document uses.
import type { jsPDF } from 'jspdf';
import boldUrl from './fonts/Roboto-Bold.ttf?url';
import regularUrl from './fonts/Roboto-Regular.ttf?url';

export const ROBOTO = 'Roboto';

const FACES = [
  { url: regularUrl, file: 'Roboto-Regular.ttf', style: 'normal' },
  { url: boldUrl, file: 'Roboto-Bold.ttf', style: 'bold' },
] as const;

const BASE64_CHUNK = 0x8000;

function toBase64(bytes: Uint8Array): string {
  let binary = '';
  for (let i = 0; i < bytes.length; i += BASE64_CHUNK) binary += String.fromCharCode(...bytes.subarray(i, i + BASE64_CHUNK));
  return btoa(binary);
}

async function fontFile(url: string): Promise<string> {
  const response = await fetch(url);
  if (!response.ok) throw new Error(`${url}: ${response.status}`);
  return toBase64(new Uint8Array(await response.arrayBuffer()));
}

/** Adds Roboto to the document; PdfPage writes in it once it is there. If the files can't be read, the document stays in Helvetica. */
export async function embedRoboto(doc: jsPDF): Promise<void> {
  try {
    const files = await Promise.all(FACES.map((f) => fontFile(f.url)));
    FACES.forEach((f, i) => {
      doc.addFileToVFS(f.file, files[i]);
      doc.addFont(f.file, ROBOTO, f.style);
    });
  } catch (err) {
    console.error('Could not load Roboto for the PDF; using Helvetica', err);
  }
}
